const minimumReturnLabelCost = 4;
const fallbackReturnLabelCost = 8.1;
const firstClassPackageServiceMailClass = "FIRST-CLASS_PACKAGE_SERVICE";
const priorityMailClass = "PRIORITY_MAIL";

function isPositivePostageAmount(totalAmount) {
  const amount = Number(totalAmount);
  return Number.isFinite(amount) && amount > 0;
}

function findPostageRateByMailClass(postagePrices, mailClass) {
  if (!Array.isArray(postagePrices)) {
    return undefined;
  }

  return postagePrices.find((postageRate) => {
    return postageRate && postageRate.mailClass === mailClass && isPositivePostageAmount(postageRate.totalAmount);
  });
}

export function calculateReturnLabelCost(postagePrices, options = {}) {
  const firstClassPackageServiceRate = findPostageRateByMailClass(
    postagePrices,
    firstClassPackageServiceMailClass
  );
  const priorityMailRate = findPostageRateByMailClass(
    postagePrices,
    priorityMailClass
  );
  const selectedPostageRate = firstClassPackageServiceRate || priorityMailRate;

  let labelCost = fallbackReturnLabelCost;
  let actualCost = fallbackReturnLabelCost;
  let mailClass = "";

  if (selectedPostageRate) {
    actualCost = Number(selectedPostageRate.totalAmount);
    labelCost = actualCost;
    mailClass = selectedPostageRate.mailClass;
  }

  if (labelCost < minimumReturnLabelCost) {
    labelCost = minimumReturnLabelCost;
  }

  if (options.skipShipping || options.hasExchange || options.freeReturnLabel) {
    labelCost = 0;
  }

  return {
    labelCost,
    actualCost,
    mailClass
  };
}
